import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import {fetchHotoEngList} from "../../../services/redux/maintenance/hoto/action";

const HotoSiteEngineerListing = ({
                       fetchHotoEngList,
                       hotoSiteData,
                       getGOLiveFilterDropDown,
                       liveFilterDropDown,
                       match
                     }) => {
  const headers = [
    'Site Number',
    'Site Type',
    'Site Name',
    'City',
    'Assigned To',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);


  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("mainSiteCont") &&
      localStorage.getItem("mainSiteCont")
    );
    if(installationCont){
      localStorage.setItem("mainGoLive", JSON.stringify(""));
      localStorage.setItem("mainSiteCont", 0);
    }

  }, []);

  useEffect(() => {
    if (fetchHotoEngList !== null)
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("mainGoLive") &&
          localStorage.getItem("mainGoLive")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await fetchHotoEngList(match.params.team, 1, getcontractFilter);
        }else{
          await fetchHotoEngList(match.params.team, 1);
        }
        setIsLoading(false);
      })();
  }, [fetchHotoEngList]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("mainGoLive", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchHotoEngList(match.params.team, 1, filterData);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      'id',
      'site_id',
      'site_no',
      'site_type',
      'client_name',
      'city_name',
      'assigned_to',
    ];
    if (hotoSiteData && hotoSiteData.resultSets) {
      const data = hotoSiteData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: [
              {
                name: "Fill HOTO Form",
                link: (match.params.team == 2) ? `/dashboard/hoto/hoto-form/` + match.params.team : `/dashboard/hoto/hoto-install-form`,
              }
            ],
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['id'] = obj['id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(hotoSiteData.total / hotoSiteData.per_page));
    }
  }, [hotoSiteData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchHotoEngList(match.params.team, val.selected + 1, filterData);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={(match.params.team == 1) ? 'Hoto Installation Sites' : 'Hoto Maintenance Sites'}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={hotoSiteData?.from}
        onPageChange={onPageChange}
        detailList={hotoSiteData && hotoSiteData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={
          liveFilterDropDown?.site_type ? liveFilterDropDown : null
        }
        liveFilterDropDown
      />
    </Layout>
  );
};
export default HotoSiteEngineerListing;
